import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import COLORS from "shared/constants/colors";
import { getDrawerItems } from "components/Drawer/data";
import Chip from "@material-ui/core/Chip";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
import LogoImage from "assets/images/logo.png";
import InfoIcon from "@material-ui/icons/Info";
import AboutDialog from "components/Drawer/AboutModal";
import { Logo, ItemText, Blinking } from "styles/components/Drawer";

const useStyles = makeStyles({
  wrapper: {
    width: 265,
    backgroundColor: COLORS.BLACK,
    height: "100%",
    color: COLORS.WHITE,
    paddingTop: 0,
  },

  items: {
    color: COLORS.WHITE,
    height: "51px",
    padding: "14px 20px 14px 23px",
    "&:hover": {
      backgroundColor: COLORS.BLACK,
      color: COLORS.WHITE,
    },
  },
  icon: {
    color: COLORS.WHITE,
    minWidth: "fit-content",
    marginRight: "6px",
  },
  listText: {
    textDecoration: "none",
  },
  innerList: {
    background: COLORS.BLACK,
    height: "32px",
    padding: "0 15px 0 32px",
    color: COLORS.WHITE,
  },
  link: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
  },
});

const CustomDrawer = ({ open, toggle }) => {
  const [collapseVisibility, updateCollapseVisibility] = useState({});
  const [aboutModalOpen, setAboutModalOpen] = useState(false);
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const classes = useStyles();
  const drawerItems = getDrawerItems(emailid);

  const CustomListItem = ({ item, isChild }) => (
    <ListItem
      className={isChild ? classes.innerList : classes.items}
      button
      onClick={() => {
        if (item.route) {
          toggle();
          return;
        }
        updateCollapseVisibility({
          ...collapseVisibility,
          [item.title]: !collapseVisibility[item.title],
        });
      }}
    >
      <ListItemIcon className={classes.icon}>{item.icon}</ListItemIcon>

      {item?.iconOnly === undefined && (
        <ItemText>
          {item.title}
          {item?.inventory && (
            <>
              &nbsp;&nbsp;[&nbsp;
              <Blinking>
                <circle cx="5" cy="5" r="5" fill="red" />
              </Blinking>
              &nbsp;&nbsp;LIVE&nbsp;]
            </>
          )}
        </ItemText>
      )}

      {item?.newRelease && (
        <Chip
          icon={<NewReleasesIcon style={{ color: "#fff" }} />}
          label="New"
          style={{ color: "#fff", background: "#ff3c3c", marginLeft: 10 }}
          size="small"
        />
      )}
    </ListItem>
  );

  return (
    <Drawer anchor="left" open={open} onClose={toggle}>
      <Logo src={LogoImage} alt="DrawerLogo" />
      <List className={classes.wrapper}>
        {drawerItems.map((item, index) =>
          item.route ? (
            <Link
              to={item.route}
              key={`${item.title}_link_${index}`}
              className={classes.link}
            >
              <CustomListItem item={item} />
            </Link>
          ) : (
            <Fragment key={`${item.title}_${index}`}>
              <CustomListItem item={item} />
              <Collapse in={collapseVisibility[item.title]}>
                {item.childItems.map((childItem, childIndex) =>
                  childItem.route ? (
                    <Link
                      to={childItem.route}
                      className={classes.link}
                      key={`${item.title}_childLink_${childIndex}`}
                    >
                      <CustomListItem
                        isChild={true}
                        item={childItem}
                        key={`${item.title}_childLinkItem_${childIndex}`}
                      />
                    </Link>
                  ) : (
                    <CustomListItem
                      item={childItem}
                      key={`${item.title}_childItem_${childIndex}`}
                    />
                  )
                )}
              </Collapse>
            </Fragment>
          )
        )}
        <a className={classes.link}>
          <ListItem
            className={classes.items}
            button
            onClick={() => setAboutModalOpen(!aboutModalOpen)}
          >
            <ListItemIcon className={classes.icon}>
              <InfoIcon />
            </ListItemIcon>
            <ItemText>About Us</ItemText>
          </ListItem>
        </a>
      </List>
      <AboutDialog
        open={aboutModalOpen}
        setOpen={(v) => setAboutModalOpen(v)}
      />
    </Drawer>
  );
};

CustomDrawer.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
};

export default CustomDrawer;
